export default __webpack_public_path__ + "static/media/Requests_1.fd4501f7.svg";